import { ACTION_ITEM_TYPE } from './UserActionItemTabPane'
import { TypographyStyles } from '@/styles'
import { Image, Text } from '@/ui'

export const UserActionItemEmptyState = ({
  tabPaneType,
}: {
  tabPaneType: ACTION_ITEM_TYPE
}) => {
  if (tabPaneType === ACTION_ITEM_TYPE.ACTIVE) {
    return (
      <div className="flex flex-col items-center space-y-4">
        <Image
          alt="confetti"
          src="https://heard-images.s3.us-west-1.amazonaws.com/assets/celebration_confentti.png"
          height={120}
          className="mx-auto"
        />

        <Text variant={TypographyStyles.H1} textAlign="center">
          You&apos;re done!
        </Text>

        <Text
          variant={TypographyStyles.BODY_LG}
          textAlign="center"
          className="min-h-fit"
        >
          You&apos;ve finished all your to dos!
        </Text>
      </div>
    )
  }

  return (
    <Text
      variant={TypographyStyles.BODY_LG}
      textAlign="center"
      className="flex flex-col space-y-4"
    >
      You don&apos;t have any{' '}
      {tabPaneType === ACTION_ITEM_TYPE.UPCOMING ? 'upcoming' : 'complete'} to
      dos.
    </Text>
  )
}
